// Pantalla `command="delete-credential"`. Required action de Keycloak
// (`delete_credential`) que se dispara cuando el usuario pulsa "Borrar"
// en el account console sobre un método de autenticación. Dos botones:
// accept (sí, eliminar) y cancel-aia (cancelar).

import type { KcData } from "../kcData";
import { StandardPage } from "../components/StandardPage";
import { msg } from "../i18n";

interface DeleteCredentialData {
  label?: string;
  // Prefix del mensaje resuelto server-side (deleteCredentialMessage
  // con {0} sustituido por ""). Por convención la message termina en
  // `: {0}`, así que `prompt` es todo el texto antes del label. El
  // bundle pinta `prompt` + <strong>{label}</strong>.
  prompt?: string;
}

function getDeleteCredential(data: KcData): DeleteCredentialData | undefined {
  return (
    (data.form?.deleteCredential as DeleteCredentialData | undefined) ??
    (data as unknown as { deleteCredential?: DeleteCredentialData })
      .deleteCredential
  );
}

export interface DeleteCredentialPageProps {
  data: KcData;
}

export function DeleteCredentialPage(props: DeleteCredentialPageProps) {
  const { data } = props;
  const dc = getDeleteCredential(data);

  // OJO: ninguno de estos dos botones lleva disabled / onClick con setState.
  // Ambos llevan name="..." (accept y cancel-aia) y dependen de que el
  // browser incluya su par name=value en el POST. En React 18 un setState
  // en onClick re-renderiza el botón como disabled antes del submit,
  // eliminando ese par del POST y rompiendo la action server-side.
  return (
    <StandardPage page="delete-credential" data={data}>
      <form
        id="kc-delete-credential-form"
        action={data.url!.loginAction}
        method="post"
      >
        <p className="instruction">
          {dc?.prompt ?? ""}
          <strong>{dc?.label ?? ""}</strong>
        </p>
        <div className="form-group">
          <button
            type="submit"
            name="accept"
            className="btn btn-lg btn-block btn-danger"
          >
            {msg("doConfirmDelete")}
          </button>
        </div>
        <div className="form-group">
          <button
            type="submit"
            name="cancel-aia"
            value="true"
            className="btn btn-lg btn-block btn-default"
          >
            {msg("doCancel")}
          </button>
        </div>
      </form>
    </StandardPage>
  );
}
